/**
 * @author Fernando FH
 * @company Erillam Healthcare
 * @version 1.0
 */

import decode from 'jwt-decode';
import Vue from 'vue';
import moment from "moment";
import router from "../router";
import cnst from "../app/core/Constants";

export default class UtilFront {

    static SHOW_COLPOSCOPY = true;
    static SHOW_TELEMEDICINE = true;

    
    static FORMAT_DATE = "DD/MM/YYYY";
    static FORMAT_DATE_TIME = "DD/MM/YYYY HH:mm";
    static FORMAT_TIME = "HH:mm"
    static VERSION = "v 1.18.3";
    static CHANGES = [];
    // static CHANGES = ["Descarga de estudios.", "Unificación de vistas.", "Etiquetas."];
    static getCurrentDateTime() {
        return moment(new Date()).local().locale("es").format('LLLL')

    }
    static getUser() {
        let user = {};
        try {
            let token = decode(sessionStorage.tokenUser);
            user = token.user;
        } catch (e) {
        }
        return user;
    }

    static getRole() {
        let role = ''
        try {
            let token = decode(localStorage.getItem('token'));
            role = token.user.role.name
            return role
        } catch (error) {
            console.log(error);
        }
        return role;
    }

    static getPreferences() {
        let preferences = {};
        try {
            preferences = JSON.parse(localStorage.getItem("preferencias"));
        } catch (e) {
            console.log(e);
        }
        return preferences;
    }

    static getIdPerson() {
        let idPerson = "";
        try {
            let user = this.getUser();
            idPerson = user.person.idPerson;
        } catch (error) {
            console.log(error);
        }
        return idPerson;
    }

    static getIdUser() {
        let idUser = "";
        try {
            let user = this.getUser();
            idUser = user.idUser;
        } catch (error) {
            console.log(error);
        }
        return idUser;
    }
    static getIdHumanResource() {
        let idHumanResource = "";
        try {
            let user = this.getUser();
            idHumanResource = user.idHumanResource;
        } catch (error) {
            console.log(error);
        }
        return idHumanResource;
    }

    static getPermissions() {
        let permissions = [];
        try {
            let permissionsDecode = decode(localStorage.getItem("pms"));
            permissions = permissionsDecode.permissions;
        } catch (error) {
            console.log(error);
        }
        return permissions;
    }

    static getBranchOffices() {
        let branchsOffices = [];
        try {
            let token = decode(sessionStorage.tokenUser);
            branchsOffices = token.branchOfficeList;
        } catch (e) {
            console.log(e);
        }
        return branchsOffices;
    }
    static withBranchOffices() {
        return this.nonEmptyList(this.getBranchOffices());
    }

    static withPermission(permissionName) {
        let withPermission = false;
        try {
            withPermission = this.getPermissions().filter((perm) => {
                return permissionName.trim().toLocaleLowerCase() == perm.name.trim().toLocaleLowerCase()
            }).length > 0;
            // withPermission = true;
        } catch (error) {
            console.log(error);
        }
        return withPermission;
    }

    static getIdBranchOffice() {
        let idBranchOffice = "";
        try {
            let user = this.getUser();
            idBranchOffice = user.person.branchOffice.idBranchOffice;
        } catch (error) {
            console.log(error);
        }
        return idBranchOffice;
    }
    static getNameBranchOffice() {
        let name = "";
        try {
            let user = this.getUser();
            if (this.nonEmpty(user) && this.nonEmpty(user.person) && this.nonEmpty(user.person.branchOffice) && this.nonEmpty(user.person.branchOffice.name)) {
                name = user.person.branchOffice.name;
            }
        } catch (error) {
            console.log(error);
        }
        return name;
    }

    static isViewAdmin() {
        let yes = false;
        try {
            yes = this.getPreferences().view_type == false;
        } catch (error) {
            console.log(error);
        }
        return yes;
    }

    static isDarkTheme() {
        let yes = false;
        try {
            let preference = this.getPreferences();
            if(this.isNonNull(preference)){
                yes = this.getPreferences().theme == false;
            }
        } catch (error) {
            console.log(error);
        }
        return yes;
    }

    static obtainAge(birthDate) {
        let old;
        const year = moment(new Date(birthDate)).local().format("YYYY");

        const month = moment(new Date(birthDate)).local().format("MM");
        const actualMonth = moment().local().format("MM");

        const day = moment(new Date(birthDate)).local().format("DD");
        const actualDay = moment().local().format("DD");

        let oldAge = moment().local().diff(year, "years");

        if (month == actualMonth) {
            if (day <= actualDay) {
                old = oldAge;
            } else {
                old = (oldAge - 1);
            }
        } else if (month > actualMonth) {
            old = (oldAge - 1);
        } else {
            old = oldAge;
        };

        if (old <= 0) {
            const actualDate = moment().local();
            const birthMonthAndYear = moment(new Date(birthDate), 'MM-YYYY').local()
            const age = moment.duration(actualDate.diff(birthMonthAndYear))
            const months = age.months()
        }

        return old;
    }

    static obtainAgeWithLabel(birthDate) {
        let old;
        const year = moment(new Date(birthDate)).local().format("YYYY");

        const month = moment(new Date(birthDate)).local().format("MM");
        const actualMonth = moment().format("MM");

        const day = moment(new Date(birthDate)).local().format("DD");
        const actualDay = moment().local().format("DD");

        let oldAge = moment().local().diff(year, "years");

        if (month == actualMonth) {
            if (day <= actualDay) {
                old = oldAge;
            } else {
                old = (oldAge - 1);
            }
        } else if (month > actualMonth) {
            old = (oldAge - 1);
        } else {
            old = oldAge;
        };

        if (old <= 0) {
            const actualDate = moment().local();
            const birthMonthAndYear = moment(new Date(birthDate), 'MM-YYYY').local()
            const age = moment.duration(actualDate.diff(birthMonthAndYear))
            const months = age.months()

            old = `${months} meses`
            if (months <= 0) {
                const days = age.days()
                old = `${days} días`
            }
        } else {
            old = `${old} años`
        }



        return old;
    }


    static notifications(msj, type) {

        if (type === 'ERROR') {

            (new Vue).$toast.error(msj);

        } else if (type === 'SUCCESS') {

            (new Vue).$toast.success(msj);

        } else if (type === 'INFO') {

            (new Vue).$toast.info(msj);

        } else if (type === 'WARNING') {

            (new Vue).$toast.warning(msj);

        } else if (type === 'DEFAULT') {

            (new Vue).$toast(msj);

        }

    }

    static errorhttp(response) {
  console.log(response);

  // axios error -> error.response
  response = response?.response;

  let status = 0;
  let message = undefined;

  if (response != undefined) {
    status = response.status;

    if (
      response.data != null &&
      typeof response.data === "object" &&
      typeof response.data.code === "number"
    ) {
      status = response.data.code;
    }
  }

  const getMessage = () => {
    if (response == null) return undefined;

    const d = response.data;

    if (typeof d === "string") return d;
    if (d != null && typeof d === "object") {
      return d.data || d.message || d.error;
    }

    return d;
  };

  switch (status) {
    case 401:
      this.notifications("No estás autorizado para ver el recurso solicitado.", "ERROR");
      localStorage.clear();
      router.replace({ name: "login" });
      break;

    case 403:
      this.notifications("No tienes permisos para realizar la tarea.", "WARNING");
      localStorage.clear();
      router.replace({ name: "login" });
      break;

    case 404:
      this.notifications("No se encontró el recurso que solicitó.", "WARNING");
      break;

    case 400:
      message = getMessage();
      message = this.nonEmpty(message)
        ? message
        : "Problemas en la solicitud, notifique al administrador.";
      this.notifications(message, "WARNING");
      break;

    case 500:
      message = getMessage();
      message = this.nonEmpty(message)
        ? message
        : "Problemas en el servidor, notifique al administrador.";
      this.notifications(message, "WARNING");
      break;

    default:
      this.notifications("Problemas en el servidor, notifique al administrador.", "WARNING");
  }
}

    static formatRange(date) {

        if (date == "" || this.date == null || date == undefined) {
            return "";
        }
        if (date.start == "" || date.start == null || date.start == undefined) {
            return "";
        }
        if (date.end == "" || date.end == null || date.end == undefined) {
            return "";
        }

        return `${moment(date.start).local().format("DD/MM/YYYY")} al ${moment(date.end ).local().format("DD/MM/YYYY")}`;

    }

    static endOfDay(date) {
        if (this.nonEmpty(date)) {
            return moment(date).local().endOf('day');
        }
        return null;
    }
    
    static startOfDay(date) {
        if (this.nonEmpty(date)) {
            return moment(date).local().startOf('day');
        }
        return null;
    }
    static endOfMonth(date) {
        if (this.nonEmpty(date)) {
            return moment(date).local().endOf('month');
        }
        return null;
    }
    static startOfMonth(date) {
        if (this.nonEmpty(date)) {
            return moment(date).local().startOf('month');
        }
        return null;
    }

    static startOfDayUTC(date) {
        if (!this.nonEmpty(date)) return null;

        const d = moment(date).format("YYYY-MM-DD");
        return moment.utc(d, "YYYY-MM-DD").startOf("day").toISOString();
    }

    static endOfDayUTC(date) {
        if (!this.nonEmpty(date)) return null;

        const d = moment(date).format("YYYY-MM-DD");
        return moment.utc(d, "YYYY-MM-DD").endOf("day").toISOString();
    }

    static formatDate(date, typeFormat=0) {
        if (this.nonEmpty(date)) {
            let format = "DD/MM/YYYY";
            switch (typeFormat) {
                case 1:
                    format = "YYYY-MM-DD"
                    break;
            }
            return moment(new Date(date)).local().locale("es").format(format);
        }
        return null;
    }

    static formatDateTime(date) {
        if (this.nonEmpty(date)) {
            // date = date.replace("[UTC]", "");
            return moment(new Date(date)).local().locale("es").format("DD/MM/YYYY HH:mm")
        }
        return null;
    }

    static formatTime(date) {
        if (this.nonEmpty(date)) {
            return moment(new Date(date)).local().format("HH:mm")
        }
        return null;
    }
    static formatTimeClock(date) {
        if (this.nonEmpty(date)) {
            return moment(new Date(date)).local().format("HH:mm:ss")
        }
        return null;
    }
    

    static stringBase64ToFile(dataurl, filename) {
        var arr = dataurl.split(',');
        var mime = arr[0].match(/:(.*?);/)[1];
        var bstr = atob(arr[1]);
        var n = bstr.length;
        var u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);

        }
        return new File([u8arr], filename, {
            type: mime
        });
    }


    static isEmptyList(list) {
        if (list != null && list != undefined && Array.isArray(list)) {
            return list.length == 0;
        }
        return true;
    }
    static nonEmptyList(list) {
        return !this.isEmptyList(list)
    }
    static nonEmpty(data, valueDafault) {
        if (valueDafault != null && valueDafault != undefined && valueDafault != "") {
            if (data != null && data != undefined && data != "") {
                return data;
            } else {
                return valueDafault;
            }
        }
        return data != null && data != undefined && data != "";
    }
    static isEmpty(data) {
        return !this.nonEmpty(data);
    }

    static isSameHR(idHumanResource) {
        return this.nonEmpty(idHumanResource) && this.getIdHumanResource() == idHumanResource;
    }

    static downloadZIP(data, filename) {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(new Blob([data], {
            type: "application/zip"
        }));
        link.setAttribute("download", filename || "Descarga.zip");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    static openPDF(data) {
        window.open(URL.createObjectURL(new Blob([data], {
            type: 'application/pdf'
        })));
    }
    static downloadXLSX(data, fileName) {
        const url = URL.createObjectURL(new Blob([data], {
            type: "application/vnd.ms-excel"
        }));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
    }
    static downloadXLSXLaboratory(data) {
        const url = URL.createObjectURL(new Blob([data], {
            type: "application/vnd.ms-excel"
        }));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Laboratorio.xlsx");
        document.body.appendChild(link);
        link.click();
    }

    static buildDateFull(dateStartISO, dateEndISO) {
        if (!this.nonEmpty(dateStartISO) || !this.nonEmpty(dateEndISO)) return null;

        const start = moment.utc(dateStartISO);
        const end   = moment.utc(dateEndISO);

        const startKey = start.format("YYYY-MM-DD");
        const endKey   = end.format("YYYY-MM-DD");

        const dayStart = start.format("D");
        const dayEnd   = end.format("D");

        const monthStart = start.locale("es").format("MMMM");
        const monthEnd   = end.locale("es").format("MMMM");

        const yearStart = start.format("YYYY");
        const yearEnd   = end.format("YYYY");

        if (startKey === endKey) {
            return `${dayStart} de ${monthStart} de ${yearStart}`;
        }

        return `${dayStart} al ${dayEnd} de ${monthEnd} de ${yearEnd}`;
    }

    static getDateEndConsulting(date, min = 15) {
        return moment(date).add(min, "m").toDate().local();
    }

    static lite() {
        return true;
    }
    static nonLite() {
        return !this.lite();
    }

    static isNull(date) {
        return date == null || date == undefined;
    }

    static isNonNull(data) {
        return !this.isNull(data);
    }

    static isJSON(dataType) {
        return dataType == "json" || dataType == "application/json";
    }

    static displayErrorBlog(data) {
        data.text().then((txt) => {
            let data = JSON.parse(txt);
            this.notifications(data.data || 'Ocurrió un error interno', "ERROR");
        });
    }

    static displayErrorPdf(data) {
        let jsonObject;
        data.text().then((txt) => {
            try {
                jsonObject = JSON.parse(txt);
            } catch (e) {
                this.openPDF(data);
            }
            this.notifications(jsonObject.data || 'Ocurrió un error interno', "ERROR");
        });
    }

    static getMedicalPracticeStatus(idStatusMedicalPractice) {

        let nameStatus = "";

        if (idStatusMedicalPractice == 1) {
            nameStatus = "Pendiente"
        } else if (idStatusMedicalPractice == 2) {
            nameStatus = "Reprogramado"
        } else if (idStatusMedicalPractice == 3) {
            nameStatus = "Atendido"
        } else if (idStatusMedicalPractice == 4) {
            nameStatus = "Cancelado"
        } else if (idStatusMedicalPractice == 5) {
            nameStatus = "No presentó"
        } else if (idStatusMedicalPractice == 6) {
            nameStatus = "Presente"
        } else {
            nameStatus = "N/A"
        }

        return nameStatus
    }

    static isAuthenticated() {
        return localStorage.getItem('token') ? true : false;
    }

    static encodeBase64(data) {
        return btoa(data);
    }

    static decodeBase64(data) {
        return atob(data);
    }

    static getColorBirads(nameBirads) {
        if(this.nonEmpty(nameBirads) && nameBirads !== 'NA'){
            return "birad" + (nameBirads.toLowerCase().split(" ")[1]);
          }
          return "gray";
    }

    static areEquals(objeto1, objeto2) {

        const keysObj1 = Object.keys(objeto1);
        const keysObj2 = Object.keys(objeto2);
        if (keysObj1.length !== keysObj2.length) {
            return false;
        }
    
        for (let key of keysObj1) {
            if (!keysObj2.includes(key)) {
                return false;
            }
            if (objeto1[key] !== objeto2[key]) {
                return false;
            }
        }
    
        return true;
    }

    static getStatusStudy(status){
        const statusFiltered = cnst.statusNameStudies.find((item) => {
            return item.status === status;
        });
        if(this.isNonNull(statusFiltered)){
          return statusFiltered;
        }
        return {name: "No definido", color: "gray", status };
    }
   

    static validResponse({code, status}){
       return ( code === 200 && status === "OK");
    }

    static async copyText(text) {
        try {
            await navigator.clipboard.writeText(text);
            this.notifications("Copiado!", "SUCCESS");
        } catch (error) {
            console.log(error);
            this.notifications("Error al copiar, intente denuevo.", "ERROR");
        }
    }
      
}